import { resourceState, resourceMutations } from '@/store/utils/resource';
import { CHANNELS } from '@/store/entities/schema_types';
import { accountChannelsClient as service } from '@/api/clients';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  actions: {
    async load(ctx, { accountId, params = {} }) {
      try {
        const response = await service.list(accountId, { params });
        const { data, meta, links } = response.data;
        const channelUuids = await ctx.dispatch('persist', { type: CHANNELS, data });
        ctx.commit('setIds', channelUuids);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);
        return Promise.resolve({
          channelUuids,
          meta,
          links,
        });
      } catch (error) {
        const { response } = error;
        return Promise.reject(response);
      }
    },
    persist(ctx, { type, data }) {
      return ctx.dispatch(
        'entities/persistEntities',
        {
          type,
          data,
        },
        { root: true }
      );
    },
  },
  getters: {
    channels({ ids }, getters, { entities }) {
      return ids.map((id) => entities.channels.byId[id]);
    },
  },
};
